module.exports = __webpack_public_path__ + "img/four-active.b4fa21bb.svg";